import Carousel from '../../components/carousel/Carousel'

import {VisibilityOutlined, VisibilityOffOutlined, CloseRounded} from '@material-ui/icons'
import { useRef, useState } from 'react'
import { loginCall } from '../../APICalls'
import { AuthContext } from '../../context/AuthContext'
import { useContext } from 'react'
import { Button, CircularProgress, IconButton, Snackbar, SnackbarContent } from '@material-ui/core'

import './login.css'
import { Link } from 'react-router-dom'
import { Fragment } from 'react'

const Login = () => {
    const [isRevealed, setIsRevealed] = useState(false)
    const [open, setOpen] = useState(true);
    const { /*user,*/ isFetching, error, dispatch } = useContext(AuthContext)
    const email = useRef()
    const password = useRef()

    //Environment variables
    const PF = process.env.REACT_APP_PUBLIC_FOLDER

    //Toggling the visibility of the password
    const showPassword = () => {
        setIsRevealed(() => !isRevealed)
    }

    //Handling the submission of the form
    const handleSubmit = (e) => {
        e.preventDefault()
        loginCall({email: email.current.value, password: password.current.value}, dispatch)
    }

    //Snackbar closing event handler
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        setOpen(false);
      };

    //Snackbar action
    const action = (
        <Fragment>
        <Button style={{ color: '#1b8b24' }} size="small" onClick={handleClose} >
            GOT IT
        </Button>
          {/* <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton> */}
        </Fragment>
      );
    
    return (
        <div className="login">
            <div className="loginWrapper">
                <div className='snackbar'>
                <Snackbar
                    open={open}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                      }}
                    autoHideDuration={6000}
                    onClose={handleClose}
                >
                    <SnackbarContent
                        style={{ backgroundColor: '#fff', color: '#333', fontWeight: "500" }}
                        message="Our backend hosting service may take a moment to restart after 15 minutes of inactivity. Subsequent requests will be faster"
                        action={action}
                    />
                </Snackbar>
                </div>
                <div className="loginLeft">
                    <form className="loginBox" onSubmit={handleSubmit}>
                        <div className='loginBloomLogoWrapper'>
                            <img src={PF + 'person/bloom logo.png'} className='loginBloomLogo'/>
                            <h5 className='welcomeToBloom'>Welcome to Bloom</h5>
                            <p className='welcomeToBloomParagraph'>
                                The website where you can share your love of nature, your photos 
                                and your experiences with other photographers and with the world.
                            </p>
                        </div>
                        {   
                            error &&
                            <div className="alert alert-danger" role="alert">
                                {error.response.data.msg}
                            </div>
                        }
                        <div className="inputField">
                            <input type="text" className="loginInput" ref={email} placeholder="Email"/>
                        </div>
                        <div className="inputField">
                            <input type={isRevealed ? "text" : "password"} className="loginInput" ref={password} placeholder="Password"/>
                            <span className="showPassword" onClick={showPassword}>{isRevealed ?  <VisibilityOffOutlined /> : <VisibilityOutlined />}</span>
                        </div>
                        {/* <span className="forgotPassword">Forgot your password?</span> */}
                        <div className="loginLeftBottom" >
                            <button className="loginButton" disabled={isFetching}>{isFetching ? <CircularProgress size={'25px'} style={{color: "white"}}/> : 'Sign In'}</button>
                            <Link to={'/register'} style={{textDecoration: 'none'}}>
                                <p className="createAccount">Create an Account</p>
                            </Link>
                        </div>
                    </form>
                </div>
                <div className="loginRight">
                    <Carousel/>
                </div>
            </div>
        </div>
    )
}

export default Login
